var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"stay"},[_c('header-component'),_vm._v(" "),_c('section',[_c('hero-section'),_vm._v(" "),_c('faq',{attrs:{"type":"spaces"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }